module.exports = __webpack_public_path__ + "img/mlegends.5c58f080.png";